import {
    GET_ME_INFO_ERROR,
    GET_ME_INFO_START,
    GET_ME_INFO_SUCCESS,
    LOGOUT,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.info, action = {type: ''}) => {
    switch (action.type) {
        case GET_ME_INFO_START:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case GET_ME_INFO_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case GET_ME_INFO_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        case LOGOUT:
            return initialState.user.info;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer/getMeInfoReducer.js